module.exports = __webpack_public_path__ + "static/media/commentsicon.06e4e5bc.svg";